var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "modal",
      attrs: {
        heading: "Confirmation",
        open: _vm.open,
        "times-button": _vm.timesButton,
        "static-backdrop": _vm.staticBackdrop
      }
    },
    [
      _c("div", {
        staticClass: "text-center f-18",
        domProps: { innerHTML: _vm._s(_vm.message) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x" }, [
        _c(
          "div",
          { staticClass: "small-12 medium-offset-3 medium-6 mt-3 f-18" },
          [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cellphone,
                    expression: "cellphone"
                  }
                ],
                staticClass: "input-group-field",
                attrs: { type: "text", placeholder: "Your cellphone number" },
                domProps: { value: _vm.cellphone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cellphone = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-button" }, [
                _c("input", {
                  staticClass: "button",
                  attrs: { type: "button", value: "Submit" },
                  on: { click: _vm.update }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.errors.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.errors, function(error) {
                    return _c(
                      "div",
                      { key: error, staticClass: "text-danger" },
                      [_c("small", [_vm._v(" " + _vm._s(error))])]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a631904", { render: render, staticRenderFns: staticRenderFns })
  }
}